import {ConnectedService} from "../connected-service";
import {ConnectedServiceType} from "../connected-service-type";
import {ICustomer} from "../customers";

export const hasUmojoAnalyticsByUniqueId = (serviceUniqueIds: ConnectedService[]) => {
    return serviceUniqueIds.includes(ConnectedService.UmojoAnalytics);
};

export const hasNexPark = (customer: ICustomer) => {
    return ConnectedServices(customer).includes(ConnectedServiceType.NexPark);
};

export const hasNexCity = (customer: ICustomer) => {
    return ConnectedServices(customer).includes(ConnectedServiceType.NexCity);
};

export const hasUmojoAnalytics = (customer: ICustomer) => {
    return ConnectedServices(customer).includes(ConnectedServiceType.UmojoAnalytics);
};

export const hasNexResponse = (customer: ICustomer) => {
    return ConnectedServices(customer).includes(ConnectedServiceType.NexResponse);
};

const ConnectedServices = (customer: ICustomer) => {
    return customer.connectedServices?.map(cs => cs.id) || [];
}
